export default __webpack_public_path__ + "static/media/SourceSansPro-SemiBold.43cc81b4.ttf";